import { fmt, isZero } from "@/lib/format";

const Stat = ({ label, value, testId, tone = "" }) => (
  <div className={`shrink-0 min-w-[120px] px-4 py-3 border-r border-slate-300 last:border-r-0 ${tone}`}>
    <p className="text-[10px] font-semibold uppercase tracking-[0.15em] opacity-70">{label}</p>
    <p className="font-mono text-lg sm:text-xl font-semibold tabular-nums tracking-tight mt-0.5" data-testid={testId}>{value}</p>
  </div>
);

export const TotalsStrip = ({ t }) => (
  <div className="ledger-scroll flex overflow-x-auto bg-white border border-slate-300" data-testid="totals-strip">
    <Stat label="Deposit" value={fmt(t.deposit)} testId="kpi-total-deposit-value" />
    <Stat label="Withdrawal" value={fmt(t.withdrawal)} testId="kpi-total-withdrawal-value" />
    <Stat label="Cashout" value={fmt(t.cashout)} testId="kpi-total-cashout-value" />
    <Stat label="Bonus" value={fmt(t.bonus)} testId="kpi-total-bonus-value" />
    <Stat label="Difference" value={fmt(t.pnl)} testId="kpi-net-pnl-value"
      tone={isZero(t.pnl) ? "bg-green-100 text-green-900" : "bg-red-100 text-red-800"} />
    <Stat label="Closing Avail" value={t.closing_available == null ? "—" : fmt(t.closing_available)} testId="kpi-closing-available-value" tone="bg-cyan-100 text-cyan-950" />
    <Stat label="Mismatches" value={`${t.mismatches} / ${t.count}`} testId="kpi-mismatch-value"
      tone={t.mismatches ? "text-red-700" : "text-green-700"} />
  </div>
);
